document.addEventListener('DOMContentLoaded', () => {

  const dropdown = document.querySelector('dropdown-component');
  if (!dropdown) return;

  const button = dropdown.querySelector('.label-change-view');
  if (!button) return;

  const activeView = dropdown.querySelector('li.active');
  if (activeView) {
    const labelChangeView = button.textContent.split(':')[0].trim();
    button.textContent = `${labelChangeView}: ${activeView.textContent.trim()}`;
  }

  const productList = document.querySelector('#ProductGridContainer');
  if (!productList) return;

  dropdown.addEventListener('click', (event) => {
    const clickedLi = event.target.closest('li[data-value]');
    if (!clickedLi) return;
    event.preventDefault();

    dropdown.querySelectorAll('li[data-value]').forEach(li =>
      li.classList.toggle('active', li === clickedLi)
    );

    const labelChangeView = button.textContent.split(':')[0].trim();
    button.textContent = `${labelChangeView}: ${clickedLi.textContent.trim()}`;

    productList.classList.toggle('worn', clickedLi.dataset.value === 'worn');
  });
});